import { useState } from 'react';
import Input from '../../components/Input';
import './recover-password.css';
import { useUI } from '../../UIContext';
import { post } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { handleErr } from '../../utils/functions';

function RecoverPassword() {
    const { setLoading, loading, setMessage } = useUI();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [shouldValidateEmail, setShouldValidateEmail] = useState(false);
    

    async function onClickRecoverPassword(e) {
        e.preventDefault();

        const normalizedEmail = email.trim();
        setShouldValidateEmail(true);

        if (!normalizedEmail) {
            setMessage({
                type: 'warning',
                text: 'Informe o e-mail para recuperar a palavra-passe.'
            });
            return;
        }

        setLoading(true);

        const data = {
            email: normalizedEmail
        };

        await post('/user/send-password-recovery', data, false, setMessage,
            () => {
                setMessage({
                    type: 'success',
                    text: 'Um e-mail foi enviado para gerar uma nova palavra-passe.'
                });

                navigate('/login');
            },
            (err) => {
                if (err?.response?.status === 404) {
                    setMessage({
                        type: 'warning',
                        text: 'O endereço de e-mail informado não foi encontrado.'
                    });
                    return;
                }

                handleErr(setMessage, `Não foi possível enviar o e-mail de recuperação de palavra-passe: ${err}`);
            },
            () => {
                setLoading(false);
            },
            'none',
            'none'
        )
    }

    return (
        <div className='recover-password-content'>
            <div className='recover-password-container container'>
                <h2>Recuperar a palavra-passe</h2>

                <form>
                    <Input
                        className='glass-effect-15'
                        type='text'
                        placeholder='E-mail'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        shouldValidate={shouldValidateEmail}
                        onValidate={() => !!email.trim()}
                        warningMsg='Informe o e-mail.'
                        maxLength={256}
                    />

                    <input
                        id="confirm-button"
                        className={ loading ? 'blocked-button' : "blue-button" }
                        type="submit"
                        value={ loading ? 'Carregando...' : 'Entrar' }
                        disabled={loading}
                        onClick={onClickRecoverPassword}
                    />
                </form>
            </div>
        </div>
    );
}

export default RecoverPassword;